import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getVersionWebAPI, getVersionWebAPISuccess } from '../../state/version/Version.actions';
import AppFooter from './AppFooter';

class AppFooterContainer extends Component {
  componentDidMount() {
    this.props._getVersionWebAPI();
  }

  render() {
    return (
      <AppFooter
        webAPIVersion={this.props.version.content}
        dashboardVersion={window.dashboardVersion}
      />
    );
  }
}

const mapStateToProps = state => ({
  version: state.version
});

const mapDispatchToProps = dispatch => ({
  _getVersionWebAPI: () => {
    return getVersionWebAPI()
      .then(res => dispatch(getVersionWebAPISuccess(res.body)))
      .catch(err => console.log(err));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AppFooterContainer);
